"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Image = void 0;
var color_1 = require("./color");
exports.Image = {
  /** Create a new image filled with transparent black */
  create: function (width, height) {
    return {
      nColumns: width,
      nRows: height,
      values: new Uint8ClampedArray(width * height * 4)
    };
  },
  /** Clear the whole image to transparent black */
  clear: function (image) {
    image.values.fill(0);
  },
  /** Get color of pixel `x,y` in `image`. */
  getColor: function (image, x, y) {
    return color_1.Color.fromAragabaArray(image.values, 4 * (y * image.nColumns + x));
  },
  /** Set pixel `x,y` in `image` to `color` */
  setColor: function (image, x, y, color) {
    return color_1.Color.toAragabaArray(color, image.values, 4 * (y * image.nColumns + x));
  },
  /** Add `color` to current value of pixel `x,y` in `image` (i.e. set the pixel to the sum of its current color + `color`) */
  addColor: function (image, x, y, color) {
    return color_1.Color.addToAragabaArray(color, image.values, 4 * (y * image.nColumns + x));
  },
  /** Draw a filled rectangle to the image. Only use for non-overlapping rectangles!!! */
  addRect: function (image, xmin, ymin, xmax, ymax, fill) {
    xmin = Math.min(Math.max(xmin, 0), image.nColumns); // uglier but faster than lodash clamp
    xmax = Math.min(Math.max(xmax, 0), image.nColumns);
    ymin = Math.min(Math.max(ymin, 0), image.nRows);
    ymax = Math.min(Math.max(ymax, 0), image.nRows);
    var xFrom = Math.floor(xmin);
    var yFrom = Math.floor(ymin);
    var xTo = Math.ceil(xmax); // exclusive
    var yTo = Math.ceil(ymax); // exclusive
    for (var y = yFrom; y < yTo; y++) {
      var yWeight = Math.min(y + 1, ymax) - Math.max(y, ymin);
      for (var x = xFrom; x < xTo; x++) {
        var xWeight = Math.min(x + 1, xmax) - Math.max(x, xmin);
        var effectiveFill = color_1.Color.scaleAlpha(fill, xWeight * yWeight);
        exports.Image.addColor(image, x, y, effectiveFill);
        // Color.addToImage(effectiveFill, image, x, y);
      }
    }
  },
  /** Convert `Image` (ARaGaBa) to regular `ImageData` (RGBA) */
  toImageData: function (image, out) {
    for (var i = 0, n = image.values.length; i < n; i += 4) {
      var color = color_1.Color.fromAragabaArray(image.values, i);
      color_1.Color.toRgbaArray(color, out.data, i);
    }
    return out;
  },
  /** Throw error if the length of `values` does not correspond to image size */
  validateLength: function (image) {
    if (image.values.length !== 4 * image.nColumns * image.nRows) {
      throw new Error('ValueError: length of image.values must be 4 * image.nColumns * image.nRows');
    }
  }
};